import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1722b1f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "operator-field" }
const _hoisted_4 = { class: "number-field" }
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldCheckbox = _resolveComponent("FormFieldCheckbox")!
  const _component_FormFieldMultiSelect = _resolveComponent("FormFieldMultiSelect")!
  const _component_FormField = _resolveComponent("FormField")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (_ctx.fieldList && _ctx.fieldList.type === 'TRUE_FALSE')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_FormFieldCheckbox, {
              checked: _ctx.fieldCondition.checkbox,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fieldCondition.checkbox) = $event)),
              label: _ctx.fieldList.name,
              name: `checkbox${_ctx.index}`,
              class: "margin-0"
            }, null, 8, ["checked", "label", "name"])
          ]))
        : (_ctx.fieldList && _ctx.fieldList.type === 'NUMBER')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_FormFieldMultiSelect, {
                  "selected-options": _ctx.fieldCondition.operator,
                  "onUpdate:selected-options": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fieldCondition.operator) = $event)),
                  clearable: true,
                  name: `operator${_ctx.index}`,
                  label: "Оператор",
                  options: _ctx.operatorOptionList,
                  class: "margin-0"
                }, null, 8, ["selected-options", "name", "options"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_FormField, {
                  value: _ctx.fieldCondition.number,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fieldCondition.number) = $event)),
                  type: "number",
                  name: `number${_ctx.index}`,
                  class: "margin-0"
                }, null, 8, ["value", "name"])
              ])
            ]))
          : (
          _ctx.fieldList &&
          (_ctx.fieldList.type === 'SELECT' || _ctx.fieldList.type === 'COLOR')
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_FormFieldMultiSelect, {
                  "selected-options": _ctx.fieldCondition.options,
                  "onUpdate:selected-options": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fieldCondition.options) = $event)),
                  clearable: true,
                  name: `options${_ctx.index}`,
                  options: _ctx.fieldOption,
                  class: "margin-0"
                }, null, 8, ["selected-options", "name", "options"])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}